module.exports = __webpack_public_path__ + "img/workOrderbgNo.05654f68.png";